import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Alicia Martínez Ibarra',
    text: 'Sabes que también tenía mis dudas sobre este libro porque ya en internet uno duda de todo, pero me arriesgué y sinceramente me encantó. Me llegó el correo electrónico con el acceso a todo el material de estudio. Me gustó porque las indicaciones son muy claras y detalladas paso a paso. Yo hice los primeros jabones para la casa y a todos nos gustó. Ya estoy comenzando a venderle a mis familiares y todos muy contentos. ¡De verdad te lo recomiendo, te aseguro que no te vas a arrepentir!',
    rating: 5
  }, {
    name: 'Marta Judith Velásquez García',
    text: 'Muchas gracias, ya recibí los libros y me sorprendió lo rápido que llegaron. Me encantó porque son muy claros y detallados para las personas que no conocíamos mucho del tema. ¡Estoy muy feliz de iniciar mi propio negocio!',
    rating: 5
  }, {
    name: 'Fabián Morales',
    text: 'Buenísimo el libro, muy bien explicado cada detalle. Lo estoy leyendo en este momento.',
    rating: 5
  }, {
    name: 'Testimonial Anónimo',
    text: 'Muy buenas tardes... qué maravilla de libro... es precioso, didáctico, ameno. Realmente muy agradecida de su gestión y más aún que a pesar de la distancia, poder obtener tan valiosa herramienta de trabajo como lo es un libro... mil gracias... ¡y que tengan una gran jornada... BENDICIONES!',
    rating: 5
  }, {
    name: 'Edgardo Pais',
    text: 'Muy bueno el libro, valió la pena muchas gracias!!!',
    rating: 5
  }, {
    name: 'Gabriela Jurado',
    text: '¡Hola!! Xfin tengo mi libro, gracias!! Ahora manos a la obra!!!',
    rating: 5
  }];
  return <section className="w-full py-16 md:py-24 px-4 bg-white" data-id="element-205">
      <div className="max-w-7xl mx-auto" data-id="element-206">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-207">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-brown mb-6" data-id="element-208">
            Escucha Lo Que Dicen Nuestras Alumnas Satisfechas
          </h2>
          <p className="font-inter text-xl text-brown/80 max-w-3xl mx-auto" data-id="element-209">
            No quiero que solo confíes en MI palabra. En vez de eso, me gustaría
            que vieras lo que algunas compradoras de "Secretos de los Jabones"
            tienen que decir...
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-210">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream p-6 rounded-xl shadow-lg border-2 border-sage/20 relative" data-id="element-211">
              <QuoteIcon className="w-8 h-8 text-terracotta/20 absolute top-4 right-4" data-id="element-212" />

              {/* Rating */}
              <div className="flex gap-1 mb-4" data-id="element-213">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-214" />)}
              </div>

              {/* Testimonial Text */}
              <p className="font-inter text-sm text-brown/90 leading-relaxed mb-4" data-id="element-215">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-brown/10" data-id="element-216">
                <div className="w-10 h-10 bg-gradient-to-br from-terracotta to-sage rounded-full flex-shrink-0" data-id="element-217"></div>
                <p className="font-inter text-sm font-semibold text-brown" data-id="element-218">
                  {testimonial.name}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}